// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorStreaming = (client) => ({
    /**
     * `POST /vendor/streaming/releases`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostStreamingReleases
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/releases/route.ts
     */
    createRelease: (body, query, headers) => client.fetch("/vendor/streaming/releases", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/streaming/download`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostStreamingDownload
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/download/route.ts
     */
    download: (body, query, headers) => client.fetch("/vendor/streaming/download", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/streaming/releases`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetStreamingReleases
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/releases/route.ts
     */
    listReleases: (query, headers) => client.fetch("/vendor/streaming/releases", { method: "GET", query, headers }),
    /**
     * `POST /vendor/streaming/preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostStreamingPreview
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/preview/route.ts
     */
    preview: (body, query, headers) => client.fetch("/vendor/streaming/preview", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/streaming/session`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostStreamingSession
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/session/route.ts
     */
    updateSession: (body, query, headers) => client.fetch("/vendor/streaming/session", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/streaming/upload`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPostStreamingUpload
     * @source packages/medusa-plugin-streaming-media/src/api/vendor/streaming/upload/route.ts
     */
    upload: (body, query, headers) => client.fetch("/vendor/streaming/upload", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=streaming.js.map